'use client'

import React, { createContext, useState, useContext, useEffect } from 'react'
import { useAuth } from './AuthContext'
import { api } from '../configs/api'

export type TargetDataType = {
    id: string | number
    name: string
    color?: string
}

type TargetType = {
    targets: TargetDataType[]
    setTargets: (value: TargetDataType[]) => void
    filteredTargets: TargetDataType[]
    setFilteredTargets: (value: TargetDataType[]) => void
}

const Target = createContext<TargetType | undefined>(undefined)

export const TargetProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { unity } = useAuth()
    const [targets, setTargets] = useState<TargetDataType[]>([])
    const [filteredTargets, setFilteredTargets] = useState<TargetDataType[]>([])

    const loadTargets = async () => {
        if (!unity) return

        const response = await fetch(`${api}target/getData`, {
            method: 'POST',
            body: JSON.stringify({
                unityID: unity.unityID
            })
        })
        const result = await response.json()

        setTargets(result.targets)
        setFilteredTargets(result.targets)
    }

    useEffect(() => {
        //* Carrega etiquetas
        loadTargets()
    }, [unity])

    return (
        <Target.Provider
            value={{
                targets,
                setTargets,
                filteredTargets,
                setFilteredTargets
            }}
        >
            {children}
        </Target.Provider>
    )
}

export function useTarget() {
    const context = useContext(Target)
    if (context === undefined) {
        throw new Error('useCreate must be used within a TargetProvider')
    }
    return context
}
